const EXCLUDE_FAMILY = new Set(['IS_NOT', 'NOT_IN']);
const INCLUDE_FAMILY = new Set(['IS', 'IN']);

export function defaultOperatorForDataType(): string {
	return 'IS';
}

export function operatorForValues(current: string, values: string[]): string {
	const multi = values.length > 1;
	if (EXCLUDE_FAMILY.has(current)) {
		return multi ? 'NOT_IN' : 'IS_NOT';
	}
	if (INCLUDE_FAMILY.has(current)) {
		return multi ? 'IN' : 'IS';
	}
	return current;
}
